import { useContext } from 'react'

import { FormContext } from './reward-context'

export const useRewardContext = () => {
  const context = useContext(FormContext)
  if (!context) {
    throw new Error('useRewardContext must be used within a FormProvider')
  }
  return context
}
